import * as React from 'react';
import { Link } from 'react-router-dom';

import { CategoryData } from '../App';
import { getPath, getCategoryLinkID } from './TemplateUtils';
import * as styles from '../css/CategorySidebar.less';


interface CategorySidebarProps {
    categories: Array<CategoryData>;
    currentCategory?: CategoryData;
    basePath: string;
    categoryString: string;
}

export class CategorySidebar extends React.Component<CategorySidebarProps, any> {
    constructor(props: CategorySidebarProps) {
        super(props);
    }

    render() {
        return (
            <div className={ 'sb-nav' }>
                <div className={ styles.sbTitle + ' h4 btm-18' }>{ this.props.categoryString }</div>
                <div className={ styles.divide + ' btm-18' } />
                <ul className={ styles.categorySidebarList + ' small' }>
                    { this.props.categories.map(category => {
                        const path = getPath(this.props.basePath, category.slug);
                        const sidebarID = getCategoryLinkID(category.slug, 'category-sidebar');

                        let itemStyleClassName = styles.categoryListItem;
                        if (this.props.currentCategory && category.slug === this.props.currentCategory.slug) {
                            itemStyleClassName = styles.catagorySelectedItem;
                        }
                        return <Link to={ path } key={ category.slug + '_link' } className={ itemStyleClassName + ' no-underline' }>
                            <li id={ sidebarID } className={ styles.categorySidebarListItem } key={ category.slug + '_list' }>
                                { category.short_name }
                            </li>
                        </Link>;
                    }) }
                </ul>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/CategorySidebar.tsx